<app-header></app-header>
<div class="flex flex-wrap">
    <div class="w-full sm:w-8/12 mb-10">
      <div class="container mx-auto h-full sm:p-10">
        <nav class="flex px-4 justify-between items-center">
          <div class="text-4xl font-bold">
            Explora. Asegúrate. Crece<span class="text-vjblue">.</span>
          </div>
          
        </nav>
        <header class="container px-4 lg:flex mt-10 items-center h-full lg:mt-0">
          <div class="w-full">
            <h1 class="text-4xl lg:text-6xl font-bold">VoyJaleas<span class="text-vjblue"> tu puente</span> hacia una experiencia segura en Europa</h1>
            <div class="w-20 h-2 text-vjblue my-4"></div>
            <p class="text-xl mb-10">Sabemos que vivir en Europa es un sueño… y queremos que lo hagas con la tranquilidad que necesitas. Te ayudamos a <span class="text-vjblue" style="font-weight: 900;"> contratar tu seguro médico </span> oficial, requerido para el visado, rápido, válido y 100% online.</p>
            <button class="vjblue text-white text-2xl font-medium px-4 py-2 rounded shadow" (click)="goToWebapp()">Asegúrate ahora con nosotros & ASISA</button>
            <br>
            <br>
            <a class="btn btn-outline-secondary" (click)="goToCalendly()">¿Dudas? Reserva una videollamada GRATIS</a>
          </div>
        </header>
      </div>
    </div>
    <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/7efc6206-b61a-4aa6-50b2-69f05fbe7700/public" alt="Leafs" class="w-full h-48 object-cover sm:h-screen sm:w-4/12">
</div>

<app-webapp-banner></app-webapp-banner>

<div class="container my-5">
    <h2 class="text-center mb-4">Beneficios de contratar con VoyJaleas</h2>
    <div class="row">
        <div class="col-md-4 mb-3" *ngFor="let b of beneficios">
        <div class="card h-100 shadow-sm benefit-card">
            <div class="card-body">
            <h5 class="card-title text-success">{{ b.icon }} {{ b.titulo }}</h5>
            <p class="card-text">{{ b.descripcion }}</p>
            </div>
        </div>
        </div>
    </div>
</div>
  
  <div class="bg-light py-5 text-center">
    <div class="container">
      <blockquote class="blockquote">
        <p class="mb-0">
          "No sabía cómo comenzar, pero con VoyJaleas fue fácil, claro y rápido. En menos de una semana ya tenía mi seguro aprobado y certificado para el visado."
        </p>
        <footer class="blockquote-footer">Alejandro Cedeño, ingeniero civil trabajando en Barcelona después de cursar su Máster.</footer>
      </blockquote>
    </div>
  </div>
  
  <div class="container text-center my-5">
    <h3>¡Evita complicaciones!</h3>
    <p class="lead">Un seguro médico válido es obligatorio para tu visado europeo. Nosotros te ayudamos a gestionarlo fácilmente.</p>
    <button class="vjblue text-white text-2xl font-medium px-4 py-2 rounded shadow" (click)="goToWebapp()">Comenzar ahora</button>
  </div>
  
  <app-footer-landing></app-footer-landing>